// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-select-migration-to-workbook-dialog {
  position: relative;
  max-height: calc(100vh - 32px);
}
.dl-select-migration-to-workbook-dialog__body {
  padding: 18px 32px 10px;
}
.dl-select-migration-to-workbook-dialog__body-content {
  display: flex;
  justify-content: space-between;
}
.dl-select-migration-to-workbook-dialog__block-content-item {
  flex: 1 1 0;
}
.dl-select-migration-to-workbook-dialog__block-content-item:last-child {
  margin-left: 24px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/SelectMigrationToWorkbookDialog/SelectMigrationToWorkbookDialog.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,8BAAA;AACJ;AACI;EACI,uBAAA;AACR;AAEI;EACI,aAAA;EACA,8BAAA;AAAR;AAGI;EACI,WAAA;AADR;AAGQ;EACI,iBAAA;AADZ","sourcesContent":[".dl-select-migration-to-workbook-dialog {\n  position: relative;\n  max-height: calc(100vh - 32px);\n}\n.dl-select-migration-to-workbook-dialog__body {\n  padding: 18px 32px 10px;\n}\n.dl-select-migration-to-workbook-dialog__body-content {\n  display: flex;\n  justify-content: space-between;\n}\n.dl-select-migration-to-workbook-dialog__block-content-item {\n  flex: 1 1 0;\n}\n.dl-select-migration-to-workbook-dialog__block-content-item:last-child {\n  margin-left: 24px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
